export default __webpack_public_path__ + "src/assets/adagio_logo.png";